import React, { useEffect, useState } from "react";

import DestinoFila from "./DestinoFila";
import Categorias from "./Categorias.js";
import SeccionBuscador from "./SeccionBuscador";
import BancosSlider from "./BancosSlider.js";
import { productosAPI, toolsAPI } from "../../utils/funcionesAPI";
import {
  stockEnDemanda,
  manejadorDeRespuesta,
  deJSAFechaAmericana,
  formatearFecha,
  armarFilasDelSlider,
} from "../../utils/Tools";
import { ToastContainer } from "react-toastify";
import Loader from "../Global/Loader.js";
import Modal from "../Global/Modal.js";
import ModalApp from "../Global/ModalApp";
//import ReactTooltip from 'react-tooltip'

const Home = (props) => {
  const { onSelectChange, onSelectOrigenChange, onSelectDestinoChange, onAdultosChange, onMenoresChange, onEdadChange, busqueda } = props;
  const [productos, setProductos] = useState([]);
  const [idGrupo, setIdGrupo] = useState(0);
  //const [peticionServicioProducto, setPeticionServicioProducto] = useState(6);
  const [loaded, setLoaded] = useState(false);
  const [fancy, setFancy] = useState({});
  const [isMobile, setIsMobile] = useState(false);
/*
  constructor(props) {
    super(props);
    this.state = {
      peticionServicioProducto: 6,
      idGrupo: 0,
      productos: [],
      loaded: false,
      fancy: {},
      isMobile: false
    };

    this.handleCombosBusquedaChange = this.handleCombosBusquedaChange.bind(
      this
    );
    this.handleCombosOrigenBusquedaChange = this.handleCombosOrigenBusquedaChange.bind(
      this
    );
    this.handleCombosDestinoBusquedaChange = this.handleCombosDestinoBusquedaChange.bind(
      this
    );
    this.handleAdultosChange = this.handleAdultosChange.bind(this);
    this.handleMenoresChange = this.handleMenoresChange.bind(this);
    this.handleEdadChange = this.handleEdadChange.bind(this);

    this.handleGrupoClick = this.handleGrupoClick.bind(this);
    
  }*/

  useEffect(() => {
    traerFancyBanner();
    stockEnDemanda(9);
    handleAdultosChange(2);
    window.scrollTo(0, 0);
    if (window.screen.width < 768) setIsMobile(true);
  }, []);

  useEffect(() => {
    traerProductosPorOrigen();
  }, [busqueda.origen]);

  //FC: se ejecuta una vez renderizado el DOM, ideal para meter DATA y/o manipularlo
  /*
  componentDidMount() {
    this.traerProductosPorOrigen();
    this.traerFancyBanner();
    this.handleAdultosChange(2);
    stockEnDemanda(9);
    window.scrollTo(0, 0);
    //this.traerProductosConValijaYa();
    if (window.screen.width < 768) this.setState({isMobile: true})
  }
*/

  //FC: se ejecuta una vez renderizado el DOM, luego de actualizarlo (ideal para meter DATA y/o manipularlo)
  /*
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.busqueda.origen !== this.props.busqueda.origen ||
      prevState.idGrupo !== this.state.idGrupo
    ) {
      //this.traerProductosConValijaYa();
      this.traerProductosPorOrigen();
    }
  }
*/


  const handleCombosBusquedaChange = (propiedad, valor) => {
      onSelectChange(propiedad, valor);
  }

  const handleCombosOrigenBusquedaChange = (origen) => {
      onSelectOrigenChange(origen);
  }

  const handleCombosDestinoBusquedaChange = (origen) => {
      onSelectDestinoChange(origen);
  }

  const handleAdultosChange = (cantidad) => {
      onAdultosChange(cantidad);
  }

  const handleMenoresChange = (cantidad) => {
      onMenoresChange(cantidad);
  }

  const handleEdadChange = (clave, valor) => {
      onEdadChange(clave, valor);
  }

  const handleGrupoClick = (idGrupoSeleccionado) => {
    //console.log(idGrupo);
    //setPeticionServicioProducto(9);
    setIdGrupo(idGrupoSeleccionado);
    /*
    this.setState({
      peticionServicioProducto: 9,
      idGrupo: idGrupoSeleccionado,
    });
    */
  }

  const isIphone = () => {
    //let navegador = navigator.userAgent;
    if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) ) {
    return true;
    }
    return false;
  }

  const traerProductosPorOrigen = () => {
    //var _this = this;
    let data = JSON.stringify({
      peticion: "traerProductosPorOrigen",
      origen: busqueda.origen || "CENT",
      idGrupo: idGrupo,
      canal: 'web'
    });
    setLoaded(false);
    //this.setState({ loaded: false });
    productosAPI(data).then((respuesta) => {
      setLoaded(true);
      //this.setState({ loaded: true });
      if (manejadorDeRespuesta(props, respuesta)) {
        setProductos(respuesta.data);
      }
        //this.setState({ productos: respuesta.data });
    });
  }

  const traerFancyBanner = () => {
    //var _this = this;
    let data = JSON.stringify({
      accion: "traerFancyBanner",
      origen: busqueda.origen || "CENT",
    });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        const newFancy = {
          ...respuesta.data,
          ...(respuesta.data.fechaFinalizacion && {
            fechaFinalizacion: new Date(respuesta.data.fechaFinalizacion),
          }),
        };
        setFancy(newFancy);
       // this.setState({ fancy });
      }
    });
  }

  //render() {
    //const { productos, fancy } = this.state;
    const {
      productos1raFila,
      productos2daFila,
      productos3raFila,
    } = armarFilasDelSlider(productos);
    const fechaParaGrupoComercial = formatearFecha(
      deJSAFechaAmericana(new Date())
    );

    return (
      <div>
        <SeccionBuscador
          busqueda={busqueda}
          origen={busqueda.origen}
          onSelectChange={handleCombosBusquedaChange}
          onSelectOrigenChange={handleCombosOrigenBusquedaChange}
          onSelectDestinoChange={handleCombosDestinoBusquedaChange}
          onAdultosChange={handleAdultosChange}
          onMenoresChange={handleMenoresChange}
          onEdadChange={handleEdadChange}
        />
       
        <Categorias
          onGrupoClick={handleGrupoClick}
          origen={busqueda.origen}
          fecha={fechaParaGrupoComercial}
        />

        <Loader
          loaded={loaded}
          mensaje="Buscando Paquetes, aguarde unos instantes..."
        />
        {loaded && (
          <div style={{marginTop: '1rem'}}>
            {productos1raFila.length > 0 && (
              <DestinoFila
                titulo="Destacados"
                productos={productos1raFila}
                origen={busqueda.origen}
                destino={busqueda.destino}
                fecha={busqueda.fecha}
              />
            )}
            {/*---SI HAY MAS DE 8 PRODUCTOS MUESTRO LA 2da FILA---*/}
            {productos2daFila.length > 3 && (
              <DestinoFila
                titulo="Otros Destinos"
                productos={productos2daFila}
                origen={busqueda.origen}
                destino={busqueda.destino}
                fecha={busqueda.fecha}
              />
            )}
            {/*---SI HAY MAS DE 12 PRODUCTOS MUESTRO LA 2da FILA---*/}
            {productos3raFila.length > 3 && (
              <DestinoFila
                titulo="Además"
                productos={productos3raFila}
                origen={busqueda.origen}
                destino={busqueda.destino}
                fecha={busqueda.fecha}
              />
            )}
          </div>
        )}

        <BancosSlider />

        <ToastContainer />
        {/*---MOSTRAR MODAL HASTA FECHA FINALIZACION ---*/}
        {
          !isMobile &&
            fancy.estado && 
            new Date().getTime() <= fancy.fechaFinalizacion.getTime() && <Modal fancy={fancy} />
        }
        {
  
        isMobile && !isIphone() && <ModalApp />
        }
       {/*  <div className='d-lg-none' style={{
            display:'block',
            width:'70px',
            height:'70px',
            color:'#fff',
            position: 'fixed',
            right:'20px',
            bottom:'20px',
            borderRadius:'50%',
            lineHeight:'80px',
            textAlign:'center',
            zIndex:'999'
      }}>
      <a href="https://pedraza.com.ar/turnos">
       <img src="https://pedraza.com.ar/assets/img/ico-turnos.png" alt="Logo Turnos" />
      </a>
        </div> */}
      </div>
    );
  //}
}

export default Home;
/*

  /*traerProductosConValijaYa() {
        var _this = this;

        let data = JSON.stringify({peticion: 10, origen: this.props.busqueda.origen});

        productosAPI(data)
                .then(productos => {
                  if (!productos) {
                    alert('Ha surgido un error en traer los productos promocionados');
                    return;
                  }
                    _this.setState({productosPromocionados: productos});
                });
    }
*/

/*FC: componente para mostrar en el toast

new Date().getDate() === this.state.fechaFinalizacionModal.getDate() &&
new Date().getHours() <= this.state.fechaFinalizacionModal.getHours()
class NewMessageNotification extends React.Component {

  displayMessage = () => {
    //remove all notifications
    toast.dismiss();

    //navigate to the link. I'll use location hash but it can be done with any router solution
    window.location.hash = "";
  }

  render(){
    return (
      <div style={{color: '#767676'}}>
        volver al sitio web tradicional haciendo click <a href="http://pedrazavyt.com.ar/indexTradicional.php">AQUI</a>
      </div>
    );
  }
}*/



// WEBPACK FOOTER //
// ./src/components/Home/index.js